import { useEffect } from 'react';

export const useKeypress = (key: string, action: (e?: KeyboardEvent) => void): void => {
  useEffect(() => {
    // we set fnc onKeyup inside useEffect since it depends on key & action params.
    const onKeyup = (e: KeyboardEvent) => {
      if (e.key === key) action(e);
    };
    window.addEventListener('keyup', onKeyup);
    return () => window.removeEventListener('keyup', onKeyup);
  }, [key, action]);
};
